export const messages = {
  en: {
    product: {
      home: 'Home',
      selected: 'Selected',
      category: 'Category',
      price: 'Price',
      all: 'All',
      confirm: 'Confirm',
      sort: 'Sort',
      default: 'Default',
      sales: 'Sales',
      priceSort: 'Price',
      addToCart: 'Add to Cart',
      buyNow: 'Buy Now',
      cancelSelection: 'Cancel Selection',
      classification: 'Classification',
      priceRange: 'Price Range'
    }
  },
  zh: {
    product: {
      home: '首页',
      selected: '已选择',
      category: '分类',
      price: '价格',
      all: '全部',
      confirm: '确定',
      sort: '排序方式',
      default: '默认',
      sales: '销量',
      priceSort: '价格',
      addToCart: '加入购物车',
      buyNow: '立即购买',
      cancelSelection: '取消选择',
      classification: '分类',
      priceRange: '价格区间'
    }
  }
}